import { render, staticRenderFns } from "./ActivityItemCard.vue?vue&type=template&id=c96d489a&scoped=true&"
import script from "./ActivityItemCard.vue?vue&type=script&lang=js&"
export * from "./ActivityItemCard.vue?vue&type=script&lang=js&"
import style0 from "./ActivityItemCard.vue?vue&type=style&index=0&id=c96d489a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96d489a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VIcon,VImg})
